import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { chatApi } from 'services/chat_api';

const initialState = {
  contacts: [],
  loading: false,
  error: null,
  page: 1,
  limit: 20,
  hasMore: true,
  searchQuery: "",
};

export const fetchChatContacts = createAsyncThunk(
  'chatContacts/fetchChatContacts',
  async (_, { getState, rejectWithValue }) => {
    const { page, limit, searchQuery } = getState().chatContacts;
    try {
      const res = await chatApi.getContacts({ page, limit, search: searchQuery });
      const contactList = res?.response?.contactList ?? [];
      return {
        contacts: contactList,
        page,
        hasMore: contactList.length === limit,
      };
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

const chatContactsSlice = createSlice({
  name: 'chatContacts',
  initialState,
  reducers: {
    updateContact(state, action) {
      const updated = action.payload;
      const index = state.contacts.findIndex((c) => c._id === updated._id);
      if (index !== -1) {
        state.contacts[index] = { ...state.contacts[index], ...updated };
      }
    },
    updateContactKey(state, action) {
      const { contactId, key, value } = action.payload;
      const index = state.contacts.findIndex((c) => c._id === contactId);
      if (index !== -1) {
        state.contacts[index][key] = value;
      }
    },
    resetContacts(state) {
      state.contacts = [];
      state.page = 1;
      state.hasMore = true;
    },
    setSearchQuery(state, action) {
      state.searchQuery = action.payload;
      state.page = 1;
      state.hasMore = true;
    },
    nextPage(state) {
      state.page += 1;
    },
    prependContact(state, action) {
        const incoming = action.payload;
        const existsIndex = state.contacts.findIndex(c => c.chatId === incoming.chatId);

        if (existsIndex !== -1) {
            state.contacts.splice(existsIndex, 1);
        }
        state.contacts.unshift(incoming);
        state.contacts.sort((a, b) =>
            new Date(b.lastMessage?.createdAt || 0) - new Date(a.lastMessage?.createdAt || 0)
        );
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchChatContacts.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchChatContacts.fulfilled, (state, action) => {
        state.loading = false;
        const { contacts, page, hasMore } = action.payload;
        state.contacts = page === 1 ? contacts : [...state.contacts, ...contacts];
        state.hasMore = hasMore;
      })
      .addCase(fetchChatContacts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export const {
  updateContact,
  updateContactKey,
  resetContacts,
  setSearchQuery,
  nextPage,
  prependContact
} = chatContactsSlice.actions;

export default chatContactsSlice.reducer;
